import React from "react";
import "./index.css"

const VantagemItem = ({ icon, title, text }) => {
    return (
        <div className=" bg-white rounded-[20px] hover:scale-[1.02] transition-all duration-300 shadow-xl px-2 py-6 flex justify-center items-center">

        <div className="vantagensSectionItem">
            <div className="flex flex-col gap-2"></div>
            <p className="textIcon">{icon}</p>
            <p>
                <span className="font-semibold">{title}: </span>
                {text}
            </p>
        </div>
        </div>
    );
};

export default VantagemItem;
